module.exports = __webpack_public_path__ + "img/1.938d496d.png";